import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Premium homepage banner — full-width card with image + brand name.
 * Single slot. Hides if no active ad.
 */
const HomepageHeroAd = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/ads/active`)
      .then((res) => {
        if (cancelled) return;
        const list = (res.data && res.data.homepage_hero) || [];
        if (list.length > 0) setAd(list[0]);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ad) return null;

  return (
    <section
      data-testid="homepage-hero-ad"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
    >
      <a
        href={ad.destination_url || '#'}
        target="_blank"
        rel="noopener sponsored noreferrer"
        className="group block relative overflow-hidden rounded-lg border border-[#262626] hover:border-[#D4AF37]/50 transition-all"
        aria-label={`Sponsored: ${ad.brand_name}`}
      >
        <span className="absolute top-3 left-3 z-10 text-[10px] tracking-[0.2em] uppercase text-white/80 bg-black/60 backdrop-blur-sm px-2 py-1 rounded">
          Sponsored
        </span>
        {ad.ad_image_url ? (
          <img
            src={ad.ad_image_url}
            alt={ad.brand_name}
            className="w-full h-[160px] sm:h-[220px] object-cover group-hover:scale-[1.01] transition-transform"
          />
        ) : (
          <div className="w-full h-[160px] sm:h-[220px] bg-gradient-to-br from-[#0A2216] to-[#1A1A1A] flex items-center justify-center">
            <span className="text-2xl text-[#D4AF37] font-['Bebas_Neue']">
              {ad.brand_name}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-5 flex items-end justify-between gap-4">
          <div className="min-w-0">
            <p className="text-xs text-white/70 uppercase tracking-wider">{ad.brand_name}</p>
            {ad.headline && <p className="text-white font-medium text-lg mt-1 truncate">{ad.headline}</p>}
            {ad.short_description && <p className="text-xs text-white/70 mt-1 truncate">{ad.short_description}</p>}
          </div>
          <span className="text-[#D4AF37] text-sm shrink-0 px-3 py-2 border border-[#D4AF37]/40 rounded">
            {ad.cta_text || 'Visit'} &rarr;
          </span>
        </div>
      </a>
    </section>
  );
};

export default HomepageHeroAd;
